import { injectGlobal } from "styled-components"
import { font, breakpoint, colour } from "./variables"

injectGlobal`
  @font-face {
    font-family: 'SamsungOne';
    src: url('https://ss-adtile-nfc-production.chep.dev/static/fonts/samsung-one-regular/SamsungOne-400.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url('https://ss-adtile-nfc-production.chep.dev/static/fonts/samsung-one-bold/SamsungOne-700.ttf') format('truetype');
    font-weight: 700;
    font-style: bold;
  }

  @font-face {
    font-family: 'SamsungSharpSans';
    src: url('https://ss-adtile-nfc-production.chep.dev/static/fonts/samsung-sharpsans-regular/SamsungSharpSans-Regular.ttf') format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'SamsungSharpSans';
    src: url('https://ss-adtile-nfc-production.chep.dev/static/fonts/samsung-sharpsans-medium/SamsungSharpSans-Medium.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'SamsungSharpSans';
    src: url('https://ss-adtile-nfc-production.chep.dev/static/fonts/samsung-sharpsans-bold/SamsungSharpSans-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: bold;
  }

  html,
  body {
    font-weight: ${font.weight.book};
    line-height: 1.5625;
    font-size: ${font.size.desktop.base};
    font-family: "SamsungOne", "SamsungSharpSans", sans-serif;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0 auto;
    scroll-behavior: smooth;
    color: ${colour.black};
    background-color: ${colour.white};

    input:-internal-autofill-selected {
      background-color: transparent !important;
      background-image: none !important;
      color: rgb(0, 0, 0) !important;
    }

    @media (max-width: ${breakpoint.max.medium}) {
      font-size: ${font.size.mobile.base};
    }
  }

  #__next,
  body {
    overflow-x: hidden;
  }

  #__next {
    min-height: 100vh;
  }

  * {
    box-sizing: border-box;
  }

  button {
    font-size: inherit;
  }

  ul,
  ol,
  figure {
    padding: 0;
    margin: 0;
  }

  h3 {
    font-size: 20px;
  }

  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .anchor-button {
    display: block;
    width: 50%;
    min-width: 130px;
    text-decoration: none;
    background-color: #fff;
    color: #000;
    letter-spacing: 0.2em;
    font-weight: 600;
    border: 2px solid #000;
    border-radius: 99px;
    padding: 15px;
    text-transform: uppercase;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
    margin: 10px auto;
  }

  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }


  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "SamsungSharpSans";
  }

  a {
    text-decoration: underline;
    color: #000;

    &:visited {
      color: #000;
    }
  }

  ul {
    list-style: disc;
  }
`
